var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auto-complete-box"},[_c('auto-complete',{attrs:{"source":_vm.allGuest,"placeholder":"Felhasználó keresés"},on:{"selected":_vm.selectGuest}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }